import { useStatusOverlay } from '@fs/zion-ui'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useCacheService } from '@fs/zion-cache-service'
import { cacheService } from './caches'

/**
 * UseTree.
 * @param {string} treeId - can be undefined or the tree ID
 * @returns {{data, loading, error, refetch}} the return object
 * @throws 400 - The tree id was invalid.
 * @throws 403 - Only FS admins can delete a tree.
 * @throws 404 - Tree not found.
 */
export default function useTree(treeId) {
  const [t] = useTranslation()
  const showStatusOverlay = useStatusOverlay()
  const url = treeId ? `/service/tree/tree-data/groups/trees/${treeId}` : null

  const [requestState, refetch] = useCacheService(cacheService, url, url)
  const { error } = requestState

  useEffect(() => {
    if (error) {
      console.error(error)
      showStatusOverlay({ type: 'error', message: t('group-management.tree-data.error') })
    }
  }, [showStatusOverlay, error, t])

  return { ...requestState, loading: requestState.loading, refetch }
}
